import { TournamentState } from '../../enums/tournaments.enum';

export interface BadTournamentUpdateResponse {
    error: {
        code: string;
        failures: Array<{
            errorMessage: string;
            propertyName: string;
            severity: string;
        }>;
        message: string;
    };
}

export interface UpdateTournamentStateResponse {
    id: string;
    name: string;
    state: TournamentState;
}

export interface GetBroadcastingServiceResponse {
    name: string;
    url: string;
}

export interface TournamentResult {
    id: string;
    name: string;
    imageId: string;
    place: number;
    reward: number;
}

export enum ErrorCodesToUpdateState {
    TournamentCanceledDueToNoQuorum = 'TournamentCanceledDueToNoQuorum',
    InsufficientAccountBalance = 'InsufficientAccountBalance',
}
